// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"686":"c1296dae","720":"304273b4"}[chunkId] + ".css";
};